import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {s_char_weapons} from "../_signals/s_char";
import {ICharWeapon} from "../_interfaces/ICharWeapon";

export const WeaponsGet = (cid: string) => {
    fetch(apiAddress + "/char/weapons/" + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => {
                if (data.hasOwnProperty('result')) {
                    console.log('BEWeapons get reponse', data.result);
                    s_char_weapons.value = (data.result as ICharWeapon[])
                }
            }
        )
        .catch((reason => {
            console.log('BEWeapons get catch', reason);
        }))
}

export const WeaponsCreate = (weapon: ICharWeapon) => {
    fetch(apiAddress + "/char/weapons/", createOptions('CREATE', weapon))
        .then((res) => res.json())
        .then((data) => console.log('BEWeapons create reponse', data))
        .catch((reason => console.log('BEWeapons create catch', reason)))
}

export const WeaponsUpdate = (weapon: ICharWeapon) => {
    fetch(apiAddress + "/char/weapons/", createOptions('UPDATE', weapon))
        .then((res) => res.json())
        .then((data) => console.log('BEWeapons update repsonse', data))
        .catch((reason => console.log('BEWeapons update catch', reason)))
}

export const WeaponsDelete = (weapon: ICharWeapon) => {
    fetch(apiAddress + "/char/weapons/", createOptions('DELETE', weapon))
        .then((res) => res.json())
        .then((data) => console.log('BEWeapons delete repsonse', data))
        .catch((reason => console.log('BEWeapons delete catch', reason)))
}